import { render, staticRenderFns } from "./FogotPassword.vue?vue&type=template&id=00b3a6cd&scoped=true&"
import script from "./FogotPassword.vue?vue&type=script&lang=js&"
export * from "./FogotPassword.vue?vue&type=script&lang=js&"
import style0 from "./FogotPassword.vue?vue&type=style&index=0&id=00b3a6cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3a6cd",
  null
  
)

export default component.exports